import React, { Fragment, useRef } from 'react'
import ReactDOM from "react-dom"
import BackDropModal from './backDropModal'

import { ReactComponent as Cancel } from '../../assets/icons/generals/cancel.svg';


import "./modal.scss"
import { useRequestProcessor } from '../../api/requestProcessor';
import { toast } from 'react-toastify';
import { storeSingleComments } from '../../api/comments';


const ReplyComponent = ({ data, onConfirm }) => {

    const messageRef = useRef()

    const { Mutate } = useRequestProcessor();
    const { mutate } = Mutate(
        "replyToComment",
        storeSingleComments,
        {
            onSuccess: (data) => {
                toast.success(data.message)
                setTimeout(() => { onConfirm() }, 2000)
            }
        }

    )


    function onSubmitHandler (e){
        e.preventDefault();
        let postData = {
            id:data.id,
            data:{
                comment:messageRef.current.value
            }
        }
        mutate(postData)
        // console.log(messageRef.current.value);
    }

    return (
        <form onSubmit={onSubmitHandler} className='comon--modal-container'>

            <div className='flex flex-col border-b'>
                <div className='flex items-center justify-between'>
                    <h3 className='font-bold text-2xl py-4'>پاسخ به نظر {data.name} :</h3>
                    <Cancel width={36} onClick={()=>onConfirm()} />
                </div>
                <p className='py-4'>{data.comment}</p>
            </div>
            <div>
                <h3 className='font-bold text-2xl py-4'>پاسخ شما :</h3>
                <textarea className='form-input !w-full' ref={messageRef}
                placeholder='پاسخ خود را بنویسید' rows="10">
                </textarea>
            </div>
            <div className='flex justify-end'>
                <button className='bg-blue-500 px-4 py-2 rounded-xl font-bold text-white'>ثبت پاسخ</button>
            </div>
        </form>
    )
}



const Reply = ({ data, onConfirm }) => {
    return (
        <Fragment>
            {ReactDOM.createPortal(<BackDropModal onConfirm={onConfirm} />, document.getElementById("backdrop-root"))}
            {ReactDOM.createPortal(<ReplyComponent data={data} onConfirm={onConfirm} />, document.getElementById("modal-root"))}
        </Fragment>
    )
}

export default Reply